C:\Users\playc\playMoove\maggie\src\src\components\backoffice\ClientPlanSubscriber.vue

<template lang="pug">
  .component-client-plan-subscriber  Add a subscription (Client {{ client_id }}):
    .row
      .column.large-4.align-right
        label Also show unavailables &nbsp;
          input(type="checkbox", v-model="unavailable", checked="false")
    .row
      .column
        select(v-model="selected_plan")
          option(v-for="(plan,index) in getPlans()", :value="plan.id") {{ plan.name }}
      .column
        label Free subscription
          input(type="checkbox", v-model="free_subscription", checked="true")
        label Subscribe main driver
          input(type="checkbox", v-model="subscribe_main_driver", checked="true")
    ActionButton(:action="subscribe" ) Subscribe
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../structure/ui/ActionButton'

export default {
  name: 'ClientPlanSubscriber',
  components: {ActionButton},
  data() {
    return {
      plans: [],
      selected_plan: null,
      subscribe_main_driver: true,
      free_subscription: true,
      unavailable:false,
      disabled: 'not_disabled'
    }
  },
  created() {
    var self = this
    KeplerBackofficeSdk.selects.plans(this.disabled,function (response) {
      self.plans = response
    })
  },
  mounted() {
    this.getPlans()
  },
  watch: {
    unavailable : function (newValue,oldValue) {
      this.getPlans()
    }
  },
  methods: {
    subscribe() {
      var self = this
      return KeplerBackofficeSdk.clients.select(this.client_id).subscribe(
        this.selected_plan,
        this.free_subscription,
        this.subscribe_main_driver,
        function (response) {
          //MaggieHelper.notification('subscribe-esit', 'Client subscribed')
          self.$emit('subscriptionAdded', 'added')
        })
    },
    getPlans: function () {
      if(this.unavailable) {
        return this.plans
      } else {
        return this.plans.filter((item) => {
          if(item.status === 'AVAILABLE') {
            return item
          }
        })
      }
    }
  },

  props: ['client_id']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientPlanSubscriber.vue?c75f8e1a